<template>
  <div>
  <html>
  <body>
  <head>
    <meta charset="utf-8">
    <title>{{info.title}}</title>
    <meta name="keywords" :content="info.keyword">
    <meta name="description" :content="info.summary">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>

  <header
    :class="isVisible?'header-navigation slideDown':'header-navigation slideUp'"
    id="header" :style="{height: '60px'}"
  >
    <nav>
      <div class="logo">
        <el-image v-if="info.logoPhoto" style="width: 35px;height: 35px; vertical-align: middle; margin-top: -6px;" :src="info.logoPhoto"></el-image>
        <router-link to="/">
          <a href="javascript:void(0);" v-if="info.name">{{info.name}}</a>
        </router-link>
      </div>

      <h2 id="mnavh" @click="openHead" :class="showHead?'open':''">
        <span class="navicon"></span>
      </h2>

      <ul id="starlist" :style="showHead?'display: block':''">
        <li v-for="webNavbar in webNavbarList" :key="webNavbar.uid" @click="clickWebNavbar(webNavbar)">

          <!--判断是否有下拉菜单-->
          <span  v-if="webNavbar.childWebNavbar && webNavbar.childWebNavbar.length > 0">
            <el-dropdown  trigger="click">
            <span class="el-dropdown-link" :style="{color: (saveTitle == webNavbar.url || saveTitle == webNavbar.name) ? '#007fff': webNavbar.color}">
              {{webNavbar.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="childWebNavbar in webNavbar.childWebNavbar" :key="childWebNavbar.uid">
                  <router-link :to="childWebNavbar.url" v-if="childWebNavbar.isJumpExternalUrl == 0">
                    <a href="javascript:void(0);" @click="openHead" :style="{color: childWebNavbar.color}">{{ childWebNavbar.name }}</a>
                  </router-link>
                  <a v-if="childWebNavbar.isJumpExternalUrl == 1" :href="childWebNavbar.url" :style="{color: childWebNavbar.color}" target="_blank">{{ childWebNavbar.name }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>

          <!--没有有下拉菜单-->
          <span v-else>
            <router-link :to="webNavbar.url" v-if="webNavbar.isJumpExternalUrl == 0">
                <a href="javascript:void(0);" @click="openHead" :style="{color: (saveTitle == webNavbar.url || saveTitle == webNavbar.name) ? '#007fff': webNavbar.color}" :class="[(saveTitle == webNavbar.url || saveTitle == webNavbar.name) ? 'title' : '']">{{ webNavbar.name }}</a>
            </router-link>
            <a v-if="webNavbar.isJumpExternalUrl == 1" :href="webNavbar.url" target="_blank" :class="[saveTitle == webNavbar.url || saveTitle == webNavbar.name ? 'title' : '']">{{ webNavbar.name }}</a>
          </span>
        </li>
      </ul>

      <div class="searchbox" v-bind:class="showCreateBlog||showCreateQuestion?'':'searchboxDefault'" @click.stop="()=>{}">
        <div id="search_bar" :class="(showSearch || keyword.length > 0)?'search_bar search_open':'search_bar'">
          <input
            ref="searchInput"
            class="input"
            placeholder="想搜点什么呢.."
            type="text"
            name="keyboard"
            v-model="keyword"
            v-on:keyup.enter="search"
            @click="showHotSearch"
            autocomplete="off"
            @mouseleave="onLeaveTd(false)"
          >
            <p class="search_ico" @click="clickSearchIco" :style="(browserFlag == 1)?'':'top:17px'">
            <span></span>
          </p>
        </div>

        <HotSearch v-if="dialogHotSearchVisible" @chooseitem="chooseitem" @enter="onCardEnterTd" @leave="onLeaveTd"></HotSearch>
      </div>


      <el-dropdown @command="handleCommand" class="create">
        <span class="el-dropdown-link" >
          <el-button v-if="showCreateBlog||showCreateQuestion" type="primary" size="small" icon="el-icon-edit" class="createBlog" >创作</el-button>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="showCreateBlog" command="createBlog">创作文章</el-dropdown-item>
          <el-dropdown-item v-if="showCreateBlog && showUploadBlog" command="uploadBlog">上传文章</el-dropdown-item>
          <el-dropdown-item v-if="showCreateQuestion" command="createQuestion">发起问答</el-dropdown-item>
          <el-dropdown-item  command="userMoment">发表动态</el-dropdown-item>
          <el-dropdown-item command="createProblem">发布面经</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="handleCommand" class="notice">
        <span class="el-dropdown-link" >
            <i class="el-icon-bell">
              <el-badge is-dot style="margin-top: -25px;" class="item" :value="userReceiveCommentCount" :hidden="(userReceiveCommentCount + userReceiveWatchCount + userReceivePraiseCount + userReceiveSystemCount + userReceiveMessageCount + userReceiveCollectCount) == 0"></el-badge>
            </i>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="comment" >
            评论<el-badge is-dot  :value="userReceiveCommentCount"  class="item" :hidden="userReceiveCommentCount == 0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="watch">
            关注<el-badge is-dot  :value="userReceiveWatchCount"  class="item" :hidden="userReceiveWatchCount == 0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="praise">
            点赞<el-badge is-dot  :value="userReceivePraiseCount"  class="item" :hidden="userReceivePraiseCount == 0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="collect">
            收藏<el-badge is-dot :value="userReceiveCollectCount"  class="item" :hidden="userReceiveCollectCount == 0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="system">
            系统通知<el-badge is-dot  :value="userReceiveSystemCount"  class="item" :hidden="userReceiveSystemCount == 0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="message" v-if="showChat">
            私信<el-badge is-dot  :value="userReceiveMessageCount"  class="item" :hidden="userReceiveMessageCount == 0"></el-badge>
          </el-dropdown-item>
        </el-dropdown-menu>

      </el-dropdown>

      <el-dropdown @command="handleCommand" class="userInfoAvatar">
        <span class="el-dropdown-link">
            <img v-if="!isLogin" src="../../static/images/defaultAvatar.png">
            <img :class="userInfo.userTag > 0 ?'vip-color':''" v-if="isLogin&&userInfo.photoUrl!=undefined" :src="userInfo.photoUrl" onerror="onerror=null;src=defaultAvatar">
            <img v-if="isLogin&&userInfo.photoUrl==undefined"
                 :src="defaultAvatar">
            <span class="vip-text-home pointer" v-if="userInfo.userTag > 0">v</span>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="login" v-show="!isLogin">登录</el-dropdown-item>
          <el-dropdown-item command="goUserCenter" v-show="isLogin">我的主页</el-dropdown-item>
          <el-dropdown-item command="goUserInfo" v-show="isLogin">个人中心</el-dropdown-item>
          <el-dropdown-item command="logout" v-show="isLogin && !isWeiXinBrowser">退出登录</el-dropdown-item>
        </el-dropdown-menu>

      </el-dropdown>
    </nav>
  </header>

  <WebNotice></WebNotice>
  <LoginBox v-if="showLogin" @closeLoginBox="closeLoginBox"></LoginBox>
  <!--勋章-->
  <Medal ref="medal"></Medal>


  <el-drawer
    :show-close="true"
    :visible.sync="drawer"
    :size="drawerSize"
    :append-to-body="true"
    :modal-append-to-body="false"
    :with-header="false"
    class="personalCenter">

      <el-tabs type="border-card" tab-position="left" v-model="activeName" style="margin-top: 30px; height: 94%;"  @tab-click="handleClick">
      <el-tab-pane label="个人中心" name="0" >
        <span slot="label"><i class="el-icon-user-solid"></i> 个人中心</span>
        <el-form  label-position="left" :model="userInfo" label-width="100px" :rules="rules" ref="userInfo">
          <el-form-item label="头像" :label-width="labelWidth">

            <div class="imgBody" v-if="userInfo.photoUrl">
              <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('user')" @mouseover="icon = true"></i>
              <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="userInfo.photoUrl" />
            </div>

            <div v-else class="uploadImgBody" @click="checkPhoto">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item label="昵称" :label-width="labelWidth" prop="nickName">
            <el-input v-model="userInfo.nickName" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="性别" :label-width="labelWidth">
            <el-radio v-for="gender in genderDictList" :key="gender.uid" v-model="userInfo.gender" :label="gender.dictValue" border size="medium">{{gender.dictLabel}}</el-radio>
          </el-form-item>

          <el-form-item label="钱包" :label-width="labelWidth" prop="occupation">
            <span style="font-weight: bold">{{ userAmount / 100 }}</span><span> 元</span>
            <el-button v-if="userAmount > 0" style="margin-left: 10px" type="warning" size="mini"
                      @click="withdrawAmount">提现
            </el-button>
          </el-form-item>

<!--          <el-form-item label="生日" :label-width="labelWidth">-->
<!--            <el-date-picker-->
<!--              v-model="userInfo.birthday"-->
<!--              type="date"-->
<!--              placeholder="选择日期">-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->

          <el-form-item label="邮件通知" :label-width="labelWidth">
            <el-radio v-for="item in yesNoDictList" :key="item.uid" v-model="userInfo.startEmailNotification" :label="parseInt(item.dictValue)" border size="medium">{{item.dictLabel}}</el-radio>
          </el-form-item>

          <el-form-item label="编辑器" :label-width="labelWidth">
            <el-radio v-for="item in editorModalDictList" :key="item.uid" v-model="userInfo.editorModel" :label="item.dictValue" border size="medium">{{item.dictLabel}}</el-radio>
          </el-form-item>

          <el-form-item label="邮箱" :label-width="labelWidth" prop="email">
            <el-input v-model="userInfo.email" style="width: 100%"></el-input>
          </el-form-item>

<!--          <el-form-item label="QQ号" :label-width="labelWidth" prop="qqNumber">-->
<!--            <el-input v-model="userInfo.qqNumber" style="width: 100%"></el-input>-->
<!--          </el-form-item>-->

          <el-form-item label="职业" :label-width="labelWidth" prop="occupation">
            <el-input v-model="userInfo.occupation" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="简介" :label-width="labelWidth" prop="summary">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5}"
              placeholder="请输入内容"
              style="width: 100%"
              v-model="userInfo.summary">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('editUser')">保 存</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>


        <el-tab-pane label="账号绑定" name="11">
          <span slot="label"><i class="el-icon-s-flag"></i> 账号绑定</span>
          <div style="height: 100%; overflow:auto;">

            <el-table :data="accountList"
                      style="width: 100%">
              <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>

              <el-table-column label="渠道" width="100" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.source }}</span>
                </template>
              </el-table-column>

              <el-table-column label="用户" width="150" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.nickName }}</span>
                </template>
              </el-table-column>

              <el-table-column label="绑定时间" width="160" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.bindTime }}</span>
                </template>
              </el-table-column>
            </el-table>

            <div style="margin-top: 5px; margin-bottom: 5px;">你还可以绑定以下第三方帐号进行登录</div>

            <!-- <el-tooltip content="账号密码" placement="bottom"  v-if="!loginType.password && !accountList.some(item=>{return item.source == 'LOGHE'})">
              <el-button type="warning" circle @click="goBind('password')" :disabled="loginType.password">
                <span class="iconfont">&#xe60f;</span>
              </el-button>
            </el-tooltip> -->

            <el-tooltip content="码云" placement="bottom" v-if="!loginType.gitee && !accountList.some(item=>{return item.source == 'GITEE'})">
              <el-button type="danger" circle @click="goBind('gitee')" :disabled="loginType.gitee">
                <span class="iconfont">&#xe602;</span>
              </el-button>
            </el-tooltip>

            <el-tooltip content="Github" placement="bottom" v-if="!loginType.github && !accountList.some(item=>{return item.source == 'GITHUB'})">
              <el-button type="info" circle @click="goBind('github')" :disabled="loginType.github">
                <span class="iconfont">&#xe64a;</span>
              </el-button>
            </el-tooltip>

            <el-tooltip content="QQ" placement="bottom" v-if="!loginType.qq && !accountList.some(item=>{return item.source == 'QQ'})">
              <el-button type="primary" circle @click="goBind('qq')" :disabled="loginType.qq">
                <span class="iconfont">&#xe601;</span>
              </el-button>
            </el-tooltip>

            <el-tooltip content="微信公众号" placement="bottom"  v-if="!loginType.wechat && !accountList.some(item=>{return item.source == 'WECHAT'})">
              <el-button type="success" circle @click="goBind('wechat')" :disabled="loginType.wechat">
                <span class="iconfont">&#xe66f;</span>
              </el-button>
            </el-tooltip>

          </div>
        </el-tab-pane>

      <el-tab-pane label="我的评论" name="1">
        <span slot="label"><i class="el-icon-message-solid"></i> 我的评论</span>
        <div style="height: 100%; overflow:auto;">
          <el-timeline >
            <el-timeline-item v-for="comment in commentList" :key="comment.uid" :timestamp="timeAgo(comment.createTime)" placement="top">
              <el-card>
                <div class="commentList">
                <span class="left p1">
                  <img v-if="comment.user" :src="comment.user.photoUrl ? comment.user.photoUrl:defaultAvatar" onerror="onerror=null;src=defaultAvatar" />
                  <img v-else :src="defaultAvatar" />
                </span>

                  <span class="right p1">
                  <div class="rightTop">
                    <el-link class="userName" :underline="false">{{comment.user.nickName}}</el-link>
                    <el-tag style="cursor: pointer;"  @click.native="goSource(comment)">{{comment.sourceName}}</el-tag>
                  </div>

                  <div class="rightCenter ck-content" v-highlight v-html="$xss(comment.content, options)"></div>
                </span>
                </div>
              </el-card>
            </el-timeline-item>

            <span v-if="isEnd && commentList.length == 0">
                  <el-empty description="空空如也" image=""></el-empty>
            </span>

          </el-timeline>

          <div class="isEnd">
            <div class="loadContent" @click="loadMore('comment')" v-if="!isEnd&&!loading">查看更多</div>
            <div class="lds-css ng-scope" v-if="!isEnd&&loading">
              <div style="width:100%;height:100%" class="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <span v-if="isEnd &&  commentList.length > 0 ">我也是有底线的~</span>
          </div>

        </div>
      </el-tab-pane>

      <el-tab-pane label="我的回复" name="2">
        <span slot="label">
          <i class="el-icon-s-promotion"></i> 我的回复
        </span>
        <div style="height: 100%; overflow:auto">
          <el-timeline>
            <el-timeline-item v-for="reply in replyList" :key="reply.uid" :timestamp="timeAgo(reply.createTime)" placement="top">
              <el-card>
                <div class="commentList">
                  <span class="left p1">
                    <img v-if="reply.user" :src="reply.user.photoUrl ? reply.user.photoUrl:defaultAvatar" onerror="onerror=null;src=defaultAvatar" />
                    <img v-else :src="defaultAvatar" />
                  </span>

                  <span class="right p1">

                      <div class="rightTop">
                        <el-link class="userName" :underline="false">{{reply.user.nickName}}</el-link>
                        <el-tag style="cursor: pointer;"  @click.native="goSource(reply)">{{reply.sourceName}}</el-tag>
                      </div>

                      <div class="rightCenter ck-content" v-highlight v-html="$xss(reply.content, options)"></div>
                  </span>
                </div>
              </el-card>
            </el-timeline-item>

            <span v-if="isEnd && replyList.length == 0">
                  <el-empty description="空空如也" image=""></el-empty>
            </span>

          </el-timeline>

          <div class="isEnd">
            <div class="loadContent" @click="loadMore('reply')" v-if="!isEnd&&!loading">查看更多</div>
            <div class="lds-css ng-scope" v-if="!isEnd&&loading">
              <div style="width:100%;height:100%" class="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <span v-if="isEnd  &&  replyList.length > 0 ">我也是有底线的~</span>
          </div>

        </div>
      </el-tab-pane>

      <el-tab-pane v-if="showCreateBlog" label="我的文章" name="3">
          <span slot="label"><i class="el-icon-s-order"></i> 我的文章</span>

        <div class="filter-container" style="margin: 10px 0 10px 0;" >
          <el-form :inline="true" style="margin-bottom: 8px;">
            <el-input
              @input="getBlogList(true)"
              size="mini"
              clearable
              class="filter-item"
              style="width: 120px;"
              v-model="queryParams.keyword"
              placeholder="请输入博客名"
            ></el-input>

            <el-select @change="getBlogList(true)" size="mini"  v-model="queryParams.publishKeyword" clearable placeholder="是否发布" style="width:100px">
              <el-option
                v-for="item in blogPublishDictList"
                :key="item.uid"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>

            <el-select @change="getBlogList(true)" size="mini" v-model="queryParams.originalKeyword" clearable placeholder="是否原创" style="width:110px">
              <el-option
                v-for="item in blogOriginalDictList"
                :key="item.uid"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>

            <el-select @change="getBlogList(true)" size="mini" v-model="queryParams.auditStatusKeyword" clearable placeholder="审核状态" style="width:110px">
              <el-option
                v-for="item in auditStatusDictList"
                :key="item.uid"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form>

        </div>

          <div  style="height: 100%; overflow:auto;">
            <el-timeline>
              <div
                v-for="item in userBlogList"
                :key="item.uid"
                class="myArticle"
              >
                <el-timeline-item :timestamp="item.createTime" placement="top">
                  <el-card>

                    <el-row :gutter="24">
                      <el-col :span="(item.photoList && item.photoList.length > 0)?12:0" >
                          <span class="blogpic" @click="goToInfo(item)">
                            <a href="javascript:void(0);" title>
                              <img v-if="item.photoList && item.photoList.length > 0 " v-lazy="item.photoList[0]" :key="item.photoList[0]"  alt>
                            </a>
                          </span>
                      </el-col>

                      <el-col :span="(item.photoList && item.photoList.length > 0)?12:24">
                        <div style="height: 70px;">
                          <p class="blogtext" style="font-weight: bold; cursor: pointer;" @click="goToInfo(item)">{{item.title}}</p>
                        </div>
                      </el-col>

                    </el-row>

                    <div class="bloginfo">
                      <ul>
                        <li class="author">
                          <span class="iconfont">&#xe60f;</span>
                          <a href="javascript:void(0);" @click="goToAuthor(item.author)">{{item.author}}</a>
                        </li>
                        <li class="lmname" v-if="item.blogSort">
                          <span class="iconfont">&#xe603;</span>
                          <a
                            href="javascript:void(0);"
                            @click="goToList(item.blogSort.uid)"
                          >{{item.blogSort.sortName}}</a>
                        </li>
                        <li class="view">
                          <span class="iconfont">&#xe8c7;</span>
                          <span>{{item.clickCount}}</span>
                        </li>
                        <li class="like">
                          <span class="iconfont">&#xe663;</span>
                          {{item.collectCount}}
                        </li>
                      </ul>
                    </div>

                    <div style="margin-top: 5px; float: left">
                      <el-tag v-if="item.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                      <el-tag v-if="item.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>

                      <el-tag v-if="item.auditStatus==0" type="info" style="font-size: 12px">待审批</el-tag>
                      <el-tag v-if="item.auditStatus==1" content="预览" type="danger" style="font-size: 12px">
                        <el-tooltip :disabled="item.length <= 10" class="item" placement="top">
                          <div slot="content">{{item.rejectReason}}</div>
                          <div>审核未通过</div>
                        </el-tooltip>
                      </el-tag>
                      <el-tag v-if="item.auditStatus==2" type="success" style="font-size: 12px">审核已通过</el-tag>
                    </div>

                    <div class="operation">
                      <el-row>
                        <el-tooltip v-if="item.isPublish == '0' && item.auditStatus == '2'" class="item" effect="dark" content="发布" placement="top">
                          <el-button circle type="success" size="small" icon="el-icon-document-checked" @click="handlePublish(item)"></el-button>
                        </el-tooltip>

                        <el-tooltip v-if="item.isPublish== '1' && item.auditStatus == '2'" class="item" effect="dark" content="下架" placement="top">
                          <el-button circle type="danger" size="small" icon="el-icon-document-delete" @click="handlePublish(item)"></el-button>
                        </el-tooltip>

                        <el-tooltip v-if="(item.auditStatus == '0'  && item.isPublish == '0') || (item.auditStatus == '1')" class="item" effect="dark" content="提交审核" placement="top">
                          <el-button circle type="success" size="small" icon="el-icon-user" @click="handleAudit(item)"></el-button>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                          <el-button circle type="primary" size="small" icon="el-icon-edit" @click="createBlog(true, item)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="预览" placement="top">
                          <el-button circle type="info" size="small" icon="el-icon-search" @click="goToInfo(item)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="item.auditStatus== '2' && item.isPublish == '1'" class="item" effect="dark" content="导出Markdown" placement="top">
                          <el-button circle type="warning" size="small" icon="el-icon-download" @click="handleDownload(item, 'blog')"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <el-button circle type="danger" size="small" icon="el-icon-delete" @click="handleDeleteBlog(item)"></el-button>
                        </el-tooltip>
                      </el-row>
                    </div>

                  </el-card>
                </el-timeline-item>

              </div>
              <span v-if="isEnd && userBlogList.length == 0">
                <el-empty description="空空如也，快去创作吧~" image=""></el-empty>
              </span>

            </el-timeline>

            <div class="isEnd">
              <div class="loadContent" @click="loadMore('blog')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd  &&  userBlogList.length > 0 ">我也是有底线的~</span>
            </div>

          </div>
        </el-tab-pane>

      <el-tab-pane v-if="showCreateQuestion" label="我的问答" name="8">
          <span slot="label"><i class="el-icon-s-claim"></i> 我的问答</span>

          <div class="filter-container" style="margin: 10px 0 10px 0;" >
            <el-form :inline="true" style="margin-bottom: 8px;">
              <el-input
                @input="getUserQuestionList(true)"
                size="mini"
                clearable
                class="filter-item"
                style="width: 130px;"
                v-model="queryParams.keyword"
                placeholder="请输入问答名称"
              ></el-input>

              <el-select @change="getUserQuestionList(true)" size="mini"  v-model="queryParams.publishKeyword" clearable placeholder="是否发布" style="width:100px">
                <el-option
                  v-for="item in blogPublishDictList"
                  :key="item.uid"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>

            </el-form>

          </div>

          <div style="height: 100%; overflow:auto;">
            <el-timeline>
              <div
                v-for="item in userQuestionList"
                :key="item.uid"
                class="myArticle"
              >
                <el-timeline-item :timestamp="item.createTime" placement="top">
                  <el-card>

                    <el-row :gutter="24">
                      <el-col :span="24">
                        <div style="height: 70px;">
                          <p class="blogtext" style="font-weight: bold; cursor: pointer;" @click="goToQuestionInfo(item)">{{item.title}}</p>
                        </div>
                      </el-col>

                    </el-row>

                    <div class="bloginfo">
                      <ul>
                        <li class="author">
                          <span class="iconfont">&#xe60f;</span>
                          <a href="javascript:void(0);" >{{item.user.nickName}}</a>
                        </li>
                        <li class="lmname" v-if="item.blogSort">
                          <span class="iconfont">&#xe603;</span>
                          <a
                            href="javascript:void(0);"
                            @click="goToList(item.blogSort.uid)"
                          >{{item.blogSort.sortName}}</a>
                        </li>
                        <li class="view">
                          <span class="iconfont">&#xe8c7;</span>
                          <span>{{item.clickCount}}</span>
                        </li>
                        <li class="like">
                          <span class="iconfont">&#xe663;</span>
                          {{item.collectCount}}
                        </li>
                      </ul>
                    </div>

                    <div style="margin-top: 5px; float: left">
                      <el-tag v-if="item.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                      <el-tag v-if="item.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>
                    </div>

                    <div class="operation">
                      <el-row :gutter="24">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                          <el-button circle type="primary" size="small" icon="el-icon-edit" @click="createQuestion(true, item)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="预览" placement="top">
                          <el-button circle type="info" size="small" icon="el-icon-search" @click="goToQuestionInfo(item)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="item.isPublish == '1'" class="item" effect="dark" content="导出Markdown" placement="top">
                          <el-button circle type="warning" size="small" icon="el-icon-download" @click="handleDownload(item, 'question')"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <el-button circle type="danger" size="small" icon="el-icon-delete" @click="handleDeleteQuestion(item)"></el-button>
                        </el-tooltip>
                      </el-row>
                    </div>

                  </el-card>
                </el-timeline-item>
              </div>

              <span v-if="isEnd && userQuestionList.length == 0">
                <el-empty description="空空如也，快去创作吧~" image=""></el-empty>
              </span>
            </el-timeline>

            <div class="isEnd">
              <div class="loadContent" @click="loadMore('question')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd && userQuestionList.length > 0">我也是有底线的~</span>
            </div>

          </div>
        </el-tab-pane>

      <el-tab-pane label="我的收藏" name="10">
          <span slot="label"><i class="el-icon-star-on"></i> 我的收藏</span>
        <div  style="height: 100%; overflow:auto;">
            <el-timeline>
              <div
                v-for="item in collectList"
                :key="item.uid"
                class="myArticle"
              >
                <el-timeline-item :timestamp="item.createTime" placement="top">
                  <el-card>

                    <el-row :gutter="24">
                      <el-col :span="24">
                        <div style="height: 30px;">
                          <p v-if="item.collectType == '1' && item.blog" class="blogtext"  style="font-weight: bold; cursor: pointer;" @click="goToInfo(item.blog)">{{item.blog.title}}</p>
                          <p v-if="item.collectType == '2' && item.question" class="blogtext"  style="font-weight: bold; cursor: pointer;" @click="goToQuestionInfo(item.question)">{{item.question.title}}</p>
                          <p v-if="item.collectType == '4' && item.userMoment" class="blogtext" style="font-weight: bold; cursor: pointer;" @click="goToUserMoment(item.userMoment)">用户动态</p>
                          <p v-if="item.collectType == '6' && item.problem" class="blogtext" style="font-weight: bold; cursor: pointer;" @click="goToProblem(item.problem)">{{item.problem.title}}</p>
                        </div>
                      </el-col>

                    </el-row>

                    <div v-if="item.collectType == '1' && item.blog" class="rightCenter ck-content" style="min-height: 50px; color: #8F8F8F" v-highlight v-html="$xss(item.blog.summary, options)"></div>
                    <div v-if="item.collectType == '2' && item.question" class="rightCenter ck-content" style="min-height: 50px; color: #8F8F8F" v-highlight v-html="$xss(item.question.summary, options)"></div>
                    <div v-if="item.collectType == '4' && item.userMoment" class="rightCenter ck-content" style="min-height: 50px; color: #8F8F8F" v-highlight v-html="$xss(item.userMoment.content, options)"></div>
                    <div v-if="item.collectType == '6' && item.problem" class="rightCenter ck-content" style="min-height: 50px; color: #8F8F8F" v-highlight v-html="$xss(item.problem.summary, options)"></div>

                    <div class="bloginfo">
                      <ul>
                        <li class="author pointer">
                          <el-avatar :class="item.user.userTag > 0 ?'vip-color':''" v-if="item.user"  @click.native="getUserCenter(item)" fit="fill"  size="medium"  :src="item.user.photoUrl"></el-avatar>
                          <el-avatar v-else fit="fill" size="small" src="https://empty">
                            <img :src="defaultAvatar"/>
                          </el-avatar>

                        </li>
                        <li class="lmname" style="margin-top: 10px; margin-left: -10px">
                          <a href="javascript:void(0);"  v-if="item.user" @click.native="getUserCenter(item)">{{item.user.nickName}}</a>
                        </li>
                        <li v-if="item.collectType != '4'" class="view" style="margin-top: 10px; margin-left: -5px">
                          <span class="iconfont">&#xe8c7;</span>
                          <span v-if="item.collectType == '1' && item.blog">{{item.blog.clickCount}}</span>
                          <span v-if="item.collectType == '2' && item.question ">{{item.question.clickCount}}</span>
                          <span v-if="item.collectType == '6' && item.problem ">{{item.problem.clickCount}}</span>
                        </li>
                        <li v-if="item.collectType != '4'" class="like" style="margin-top: 10px; margin-left: -5px">
                          <span class="iconfont">&#xe663;</span>
                          <span v-if="item.collectType == '1' && item.blog">{{item.blog.collectCount}}</span>
                          <span v-if="item.collectType == '2' && item.question">{{item.question.collectCount}}</span>
                          <span v-if="item.collectType == '6' && item.problem">{{item.problem.collectCount}}</span>
                        </li>

                        <li style="margin-top: 10px; margin-left: -5px">
                          <span v-if="item.collectType == '1'  && item.blog">
                            <el-tag type="primary" style="font-size: 12px">博客</el-tag>
                            <el-tag v-if="item.blog.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                            <el-tag v-if="item.blog.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>
                          </span>
                          <span v-if="item.collectType == '2'  && item.question">
                            <el-tag  type="warning" style="font-size: 12px">问答</el-tag>
                            <el-tag v-if="item.question.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                            <el-tag v-if="item.question.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>
                          </span>
                          <span v-if="item.collectType == '4'  && item.userMoment">
                            <el-tag  type="warning" style="font-size: 12px">动态</el-tag>
                            <el-tag v-if="item.userMoment.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                            <el-tag v-if="item.userMoment.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>
                          </span>
                          <span v-if="item.collectType == '6'  && item.problem">
                            <el-tag  type="warning" style="font-size: 12px">问题</el-tag>
                            <el-tag v-if="item.problem.isPublish==1" type="success" style="font-size: 12px">已上架</el-tag>
                            <el-tag v-if="item.problem.isPublish==0" type="info" style="font-size: 12px">未发布</el-tag>
                          </span>
                        </li>

                        <li style="margin-top: 5px; margin-left: -3px">
                          <el-tooltip class="item" effect="dark" content="取消收藏" placement="top">
                            <el-button circle type="danger" size="small" icon="el-icon-delete" @click="cancelCollect(item.bizUid, item.collectType)"></el-button>
                          </el-tooltip>
                        </li>
                      </ul>
                    </div>

                  </el-card>
                </el-timeline-item>
              </div>

              <span v-if="isEnd && collectList.length == 0">
                <el-empty description="空空如也，快去收藏内容吧~" image=""></el-empty>
              </span>
            </el-timeline>

            <div class="isEnd">
              <div class="loadContent" @click="loadMore('collect')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd && collectList.length > 0">我也是有底线的~</span>
            </div>

          </div>
      </el-tab-pane>

<!--      <el-tab-pane label="我的点赞" name="4">-->
<!--        <span slot="label"><i class="el-icon-star-on"></i> 我的点赞</span>-->
<!--        <div style="width: 100%; height: 840px;overflow:auto">-->
<!--          <el-timeline>-->
<!--            <el-timeline-item v-for="praise in praiseList" :key="praise.uid" :timestamp="timeAgo(praise.createTime)" placement="top">-->
<!--              <el-card>-->
<!--                <span>点赞</span><el-tag type="warning" style="cursor: pointer" v-if="praise.blog" @click.native="goToInfo(praise.blog)">{{praise.blog.title}}</el-tag>-->
<!--              </el-card>-->
<!--            </el-timeline-item>-->

<!--            <span v-if="isEnd && praiseList.length == 0">-->
<!--                <el-empty description="空空如也" image=""></el-empty>-->
<!--              </span>-->


<!--          </el-timeline>-->

<!--          <div class="isEnd">-->
<!--            <div class="loadContent" @click="loadMore('praise')" v-if="!isEnd&&!loading">查看更多</div>-->
<!--            <div class="lds-css ng-scope" v-if="!isEnd&&loading">-->
<!--              <div style="width:100%;height:100%" class="lds-facebook">-->
<!--                <div></div>-->
<!--                <div></div>-->
<!--                <div></div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <span v-if="isEnd && praiseList.length > 0">我也是有底线的~</span>-->
<!--          </div>-->

<!--        </div>-->
<!--      </el-tab-pane>-->

      <el-tab-pane label="我的记忆" name="9">
          <span slot="label"><i class="el-icon-document" ></i> 我的记忆</span>
          <div style="height: 100%; overflow:auto">
            <el-descriptions title="统计" :column="1" size="mini" border>
              <el-descriptions-item label="当前记忆力"><el-tag size="small">{{creditsLogList.length>0?creditsLogList[0].newCredits:0}}</el-tag></el-descriptions-item>
            </el-descriptions>
            <el-timeline>
              <el-timeline-item v-for="creditLog in creditsLogList" :key="creditLog.uid" :timestamp="timeAgo(creditLog.createTime)" placement="top">
                <el-card>
                  <span>来源</span><el-tag type="primary" style="cursor: pointer" >{{creditLog.actionName}}</el-tag>
                  <el-tag v-if="creditLog.changeCredits >=0" type="success" style="cursor: pointer" > +{{creditLog.changeCredits}} </el-tag>
                  <el-tag v-else-if="creditLog.changeCredits < 0" type="danger" style="cursor: pointer" > {{creditLog.changeCredits}} </el-tag>
                  <span>记忆</span>
                </el-card>
              </el-timeline-item>
              <span v-if="isEnd && creditsLogList.length == 0">
                <el-empty description="空空如也" image=""></el-empty>
              </span>
            </el-timeline>
            <div class="isEnd">
              <div class="loadContent" @click="loadMore('credits')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd && creditsLogList.length > 0">我也是有底线的~</span>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="我的积分" name="points">
          <span slot="label"><i class="el-icon-coin" ></i> 我的积分</span>
          <div style="height: 100%; overflow:auto">
            <el-descriptions title="统计" :column="1" size="mini" border>
              <el-descriptions-item label="当前积分"><el-tag size="small">{{pointsLogList.length>0?pointsLogList[0].newPoints:0}}</el-tag></el-descriptions-item>
              <el-descriptions-item label="使用积分"><el-switch v-model="userInfo.enablePoints" @change="changeEnablePoints" active-text="使用积分" inactive-text="累积积分"></el-switch></el-descriptions-item>
            </el-descriptions>
            <el-timeline>
              <el-timeline-item v-for="creditLog in pointsLogList" :key="creditLog.uid" :timestamp="timeAgo(creditLog.createTime)" placement="top">
                <el-card>
                  <span>来源</span><el-tag type="primary" style="cursor: pointer" >{{creditLog.actionName}}</el-tag>
                  <el-tag v-if="creditLog.changePoints >=0" type="success" style="cursor: pointer" > +{{creditLog.changePoints}} </el-tag>
                  <el-tag v-else-if="creditLog.changePoints < 0" type="danger" style="cursor: pointer" > {{creditLog.changePoints}} </el-tag>
                  <span>积分</span>
                </el-card>
              </el-timeline-item>
              <span v-if="isEnd && pointsLogList.length == 0">
                <el-empty description="空空如也" image=""></el-empty>
              </span>
            </el-timeline>
            <div class="isEnd">
              <div class="loadContent" @click="loadMore('points')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd && creditsLogList.length > 0">我也是有底线的~</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="我的钱包" name="wallet">
          <span slot="label"><i class="el-icon-coin" ></i> 我的钱包</span>
          <div style="height: 100%; overflow:auto">
            <el-descriptions title="统计" :column="1" size="mini" border>
              <el-descriptions-item label="当前余额"><el-tag size="small">{{ userAmount / 100 }}</el-tag></el-descriptions-item>
            </el-descriptions>
            <!-- <el-timeline>
              <el-timeline-item v-for="creditLog in pointsLogList" :key="creditLog.uid" :timestamp="timeAgo(creditLog.createTime)" placement="top">
                <el-card>
                  <span>来源</span><el-tag type="primary" style="cursor: pointer" >{{creditLog.actionName}}</el-tag>
                  <el-tag v-if="creditLog.changePoints >=0" type="success" style="cursor: pointer" > +{{creditLog.changePoints}} </el-tag>
                  <el-tag v-else-if="creditLog.changePoints < 0" type="danger" style="cursor: pointer" > {{creditLog.changePoints}} </el-tag>
                  <span>元</span>
                </el-card>
              </el-timeline-item>
              <span v-if="isEnd && pointsLogList.length == 0">
                <el-empty description="空空如也" image=""></el-empty>
              </span>
            </el-timeline> -->
            <div class="isEnd">
              <div class="loadContent" @click="loadMore('points')" v-if="!isEnd&&!loading">查看更多</div>
              <div class="lds-css ng-scope" v-if="!isEnd&&loading">
                <div style="width:100%;height:100%" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <span v-if="isEnd && creditsLogList.length > 0">我也是有底线的~</span>
            </div>
          </div>
        </el-tab-pane>

      <el-tab-pane label="我的反馈" name="5">
        <span slot="label"><i class="el-icon-phone"></i> 我的反馈</span>

        <el-collapse v-model="activeNames">
          <el-collapse-item title="反馈须知" name="1">
            <div>在使用过程中遇到的问题，可以在这里进行反馈</div>
            <div>或者关注微信公众号【记他信息】留言</div>
          </el-collapse-item>
        </el-collapse>

        <el-divider></el-divider>

        <div style="height: 100%; height: 45%;overflow:auto">
          <el-timeline>
            <el-timeline-item v-for="feedbackItem in feedbackList" :key="feedbackItem.uid" :timestamp="timeAgo(feedbackItem.createTime)" placement="top">
              <el-card class="feedbackCard">
                <div class="item">
                  <span class="title">
                    标题:
                  </span>
                  <span class="content">
                    {{feedbackItem.title}}
                  </span>
                </div>

                <div class="item">
                  <span class="title">
                    内容:
                  </span>
                  <span class="content">
                    {{feedbackItem.content}}
                  </span>
                </div>

                <div class="item">
                  <span class="title">
                    反馈状态:
                  </span>
                  <span class="content">
                    <el-tag v-for="item in feedbackDictList" :key="item.uid" :type="item.listClass" v-if="feedbackItem.feedbackStatus == item.dictValue">{{item.dictLabel}}</el-tag>
                  </span>
                </div>

                <div class="item">
                  <span class="title">
                    回复:
                  </span>
                  <span class="content">
                    {{feedbackItem.reply}}
                  </span>
                </div>
              </el-card>
            </el-timeline-item>

            <span v-if="isEnd && feedbackList.length == 0">
              <el-empty description="空空如也" image=""></el-empty>
            </span>
          </el-timeline>
        </div>

        <el-divider></el-divider>

        <el-form label-position="left" :model="userInfo" label-width="100px">
          <el-form-item label="标题" :label-width="labelWidth">
            <el-input v-model="feedback.title" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="内容" :label-width="labelWidth">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入反馈内容"
              v-model="feedback.content">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('feedback')">提 交</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>

      <el-tab-pane label="申请友链" name="6">
        <span slot="label"><i class="el-icon-share"></i> 申请友链</span>

        <el-form label-position="left" :model="blogLink" label-width="100px" ref="blogLink" :rules="linkRules">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="友链申请需知" name="1">
              <span v-html="info.linkApplyTemplate"></span>
            </el-collapse-item>
          </el-collapse>

          <el-divider></el-divider>

          <el-form-item label="网站图标">
            <div class="imgBody" v-if="blogLink.photoList">
              <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('link')" @mouseover="icon = true"></i>
              <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="blogLink.photoList[0]" />
            </div>

            <div v-else class="uploadImgBody" @click="checkPhoto">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item label="网站名称" :label-width="labelWidth" prop="title">
            <el-input v-model="blogLink.title" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="网站简介" :label-width="labelWidth" prop="summary">
            <el-input v-model="blogLink.summary" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="网站地址" :label-width="labelWidth" prop="url">
            <el-input v-model="blogLink.url" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="站长邮箱" :label-width="labelWidth" prop="email">
            <el-input v-model="blogLink.email" placeholder="用于申请通过邮件通知" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('replyBlogLink')">申 请</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="7">
        <span slot="label"><i class="el-icon-s-tools"></i> 修改密码</span>
        <el-collapse v-model="activeNames">
          <el-collapse-item title="修改密码须知" name="1">
            <div>此修改密码功能仅适用于账号和密码登录</div>
            <div>对于第三方登录的账号，无法进行密码修改</div>
          </el-collapse-item>
        </el-collapse>
        <el-form ref="userInfoForm" label-position="left" :model="userInfo" label-width="100px" :rules="userInfoRules">
          <el-form-item label="旧密码" :label-width="labelWidth" prop="oldPwd">
            <el-input type="password" v-model="userInfo.oldPwd" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="新密码" :label-width="labelWidth" prop="newPwd">
            <el-input type="password" v-model="userInfo.newPwd" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="重复密码" :label-width="labelWidth" prop="newPwd2">
            <el-input type="password" v-model="userInfo.newPwd2" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('changePwd')">提 交</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane>

    </el-tabs>
  </el-drawer>

  <!--头像裁剪-->
  <avatar-cropper
    v-show="imagecropperShow"
    :key="imagecropperKey"
    :width="300"
    :height="300"
    :url="url"
    lang-type="zh"
    @close="close"
    @crop-upload-success="cropSuccess"
  />

  <div :style="{'min-height': minHeight + 'px'}" style="padding-top: 20px">
    <router-view/>
  </div>

  <footer>
    <p v-html="info.recordNum"></p>
  </footer>

  <!--创建博客-->
  <CreateBlog v-if="dialogFormVisible" :visible="dialogFormVisible" :isEdit="isEdit" :editorModel="userInfo.editorModel" :formData="formData" @beforeClose="beforeClose"></CreateBlog>

  <!--本地上传文章-->
  <UploadBlog v-if="dialogUploadBlogVisible" :visible="dialogUploadBlogVisible" @beforeClose="beforeClose"></UploadBlog>

  <!--创建问答-->
  <CreateQuestion v-if="questionDialogFormVisible" :visible="questionDialogFormVisible" :editorModel="userInfo.editorModel" :isEdit="isEdit" :formData="questionFormData" @beforeClose="questionBeforeClose"></CreateQuestion>

  <!--发表面经-->
  <CreateProblem v-if="dialogProblemFormVisible" :visible="dialogProblemFormVisible"  :isEdit="isEdit" :formData="problemFormData" @beforeClose="problemBeforeClose"></CreateProblem>


  <!--  <ChatRoom  style="margin-top: 30px"></ChatRoom>-->


  <!-- 添加或修改对话框 -->
  <el-dialog
    title="微信公众号绑定"
    :visible.sync="wechatBindDialogVisible"
    close-on-click-modal
    :width="drawerSize"
  >
    <div style="text-align: center">
      <el-image :src="webConfig.wechatPhoto" style="width: 200px; height: 200px"></el-image>
      <el-row>
        <span style="font-size: 14px; color: #303133">扫码关注公众号，回复验证码完成绑定</span>
      </el-row>
      <el-row>
        <span style="font-size: 14px; color: #303133">绑定验证码：</span>
        <span style="color: red; font-weight: bold">{{bindInfo.bindKey}}</span>
        <i class="el-icon-refresh" @click="refreshWechatBind()" style="cursor: pointer"></i>
      </el-row>
    </div>

  </el-dialog>
  <el-dialog
    title="账号绑定"
    :visible.sync="accountNumberBindDialogVisible"
    close-on-click-modal
    :width="drawerSize"
  >
    <div style="text-align: center">
      <el-image :src="webConfig.wechatPhoto" style="width: 200px; height: 200px"></el-image>
      <el-row>
        <span style="font-size: 14px; color: #303133">扫码关注公众号，回复验证码完成绑定</span>
      </el-row>
      <el-row>
        <span style="font-size: 14px; color: #303133">绑定验证码：</span>
        <span style="color: red; font-weight: bold">{{bindInfo.bindKey}}</span>
        <i class="el-icon-refresh" @click="refreshWechatBind()" style="cursor: pointer"></i>
      </el-row>
    </div>

  </el-dialog>
  <!--提现操作-->
  <el-dialog
        title="请填写提现信息"
        :visible.sync="drawDialogVisible"
        width="30%"
        center
      >
      <div style="text-align: center">
        <el-form :rules="withdrawRules" :label-width="lineLabelWidth" :model="withdrawForm" ref="withdrawForm">

          <el-form-item
            label="微信账号"
            prop="account"
          >
            <el-input
              v-model="withdrawForm.account"
              maxlength="50"
              placeholder="请输入微信账号"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="收款码" prop="fileUid">
            <div class="imgBody" v-if="withdrawForm.photoUrl">
              <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('withdraw')"
                 @mouseover="icon = true"></i>
              <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="withdrawForm.photoUrl"/>
            </div>

            <div v-else class="uploadImgBody" @click="checkPhoto">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item
            label="提现金额"
            prop="amount"
          >
            <el-input-number v-model="withdrawForm.amount" :precision="2" :step="0.01" :min="0" :max="userAmount/100"
                             style="float: left"></el-input-number>

          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="drawDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitWithdraw">确 定</el-button>
      </span>
    </el-dialog>

  <div>
    <!--聊天-->

    <el-tooltip v-if="showChat" class="item" effect="light" content="聊天室" placement="left-end">
      <a
        href="javascript:void(0);"
        class="cd-chat cd-is-visible"
        @click="goChat"
      >
        <span style="font-size: 24px; color: #3299BB;" class="iconfont">&#xe89c;</span>
        <el-badge is-dot :value="userReceiveMessageCount" style="float: right; right: 6px;"  class="item" :hidden="userReceiveMessageCount == 0"></el-badge>
      </a>
    </el-tooltip>

    <!--暗黑模式-->
    <el-tooltip class="item" effect="light" content="暗黑模式" placement="left-end">
      <a
        v-if="darkModel == 0"
        href="javascript:void(0);"
        @click="changeDarkModel(1)"
        class="cd-dark cd-is-visible"
      >
        <span style="font-size: 26px; color: #EDC951" class="iconfont">&#xe6dd;</span>
      </a>
      <a
        v-else
        href="javascript:void(0);"
        @click="changeDarkModel(0)"
        class="cd-dark cd-is-visible"
      >
        <span style="font-size: 26px" class="iconfont">&#xe60d;</span>
      </a>
    </el-tooltip>


    <!--顶部模式-->
    <a
      href="javascript:void(0);"
      @click="returnTop"
      :class="isCdTopVisible?'cd-top cd-is-visible':'cd-top'"
    >
      <span style="font-size: 26px;" class="iconfont">&#xe6fb;</span>
    </a>
  </div>

  </body>
  </html>
  </div>
</template>

<script>
  import CreateBlog from '../components/CreateBlog'
  import CreateQuestion from '../components/CreateQuestion'
  import UploadBlog from '../components/UploadBlog'
  import CreateProblem from '../components/CreateProblem'
  import HotSearch from "../components/HotSearch"

  import AvatarCropper from '@/components/AvatarCropper'
  import {getNewBlog, getWebConfig, getWebNavbar} from "../api/index";
  import {delCookie, getCookie, setCookie} from "@/utils/cookieUtils";
  import CodeCopy from "@/components/CodeCopy";
  import {addWithdraw, getOrderAmountLogList, getRecentWithdraw} from "../api/pay";
  import {
    authVerify,
    editUser,
    updateUserPwd,
    replyBlogLink,
    deleteUserAccessToken,
    getFeedbackList,
    addFeedback,
    getAccountBindList, login,
    updateEnablePoints
  } from "../api/user";
  import {getCommentListByUser, getPraiseListByUser, getReplyListByUser} from "../api/comment";
  import {getUserReceiveNoticeCount, readUserReceiveNoticeCount} from "../api/notice"
  import LoginBox from "../components/LoginBox";
  import Medal from "../components/Medal";
  import WebNotice from "../components/WebNotice";
  import {getListByDictTypeList} from "@/api/sysDictData"
  import {getMeQuestionList} from "@/api/question"
  import {getUserBlogList, deleteBlog,publishBlog, editBlog} from "@/api/createBlog"
  import {deleteQuestion} from "@/api/question"
  import {mapMutations} from 'vuex';
  import {timeAgo} from "../utils/webUtils";
  import {getSearchModel} from "@/api/search";
  import {getCreditsListByUser} from "../api/creditsLog";
  import {getPointsListByUser} from "@/api/pointsLog";
  import {deleteCollect, getUserCollectList} from "../api/collect";
  import {Loading} from "element-ui";
  import {getBindKey, loginCheck} from "../api/wechat";
  import {getMeBlogList} from "../api/createBlog";
  import { addHotSearch } from "../api/hotSearch";
  import {downloadBlog} from "../api/blogContent";
  import { isWeiXinBrowser } from "@/utils"
  import {getCurrentUserAmount} from "../api/about";

  export default {
    name: "index",
    components: {
      Medal,
      LoginBox,
      AvatarCropper,
      CreateBlog,
      CreateQuestion,
      UploadBlog,
      CreateProblem,
      HotSearch,
      WebNotice,
    },
    data() {
      return {
        // xss白名单配置
        options : {
          whiteList: {
            a: ['href', 'title', 'target'],
            span: ['class'],
            h1: ['class'],
            h2: ['class'],
            h3: ['class'],
            h4: ['class'],
            pre: [],
            code: ['class'],
            p: ['class']
          }
        },
        webConfig: {},
        bindInfo: {},
        wechatBindDialogVisible: false,
        accountNumberBindDialogVisible: false,
        minHeight: window.screen.height - 273,
        queryParams:{
          keyword: "",
          tagKeyword: "", //标签搜索
          sortKeyword: "", //分类搜索
          publishKeyword: "", // 发布 搜索
          originalKeyword: "", // 原创 搜索
          openCommentKeyword: "", // 开启评论
          auditStatusKeyword: "", // 审核状态
        }, // 搜索条件
        // 第三方账号绑定类别
        loginType: {
          password: true,
          gitee: true,
          github: true,
          qq: true,
          wechat: true
        },
        total: 0, //总数量
        isEnd: false, //是否到底底部了
        loading: false, //是否正在加载
        pageSize: 10,
        currentPage: 0,
        dialogFormVisible: false, // 控制创建博客的弹出
        questionDialogFormVisible: false, // 控制发表问题的弹出
        dialogUploadBlogVisible: false, // 控制上传博客的弹出
        dialogProblemFormVisible: false, // 控制创建面经的弹出
        searchModel: 0, //搜索模式 0:SQL搜索、1:ES搜索、2:Solr搜索
        activeNames: ['1', '2'], //激活的折叠面板
        activeName: "0", // 激活的标签
        blogOriginalDictList: [], //是否原创字典
        blogPublishDictList: [], //是否发布字典
        yesNoDictList: [], // 是否 字典列表
        genderDictList: [], //性别 字典列表
        feedbackDictList: [], // 反馈 字典列表
        editorModalDictList: [], // 文本编辑器字典列表
        commentReportDictList: [], // 评论举报字典
        auditStatusDictList: [], // 审批状态字典
        commentReportDictDefault: null, // 评论举报字典默认值
        imagecropperShow: false,
        imagecropperKey: 0,
        url: process.env.PICTURE_API + "/file/cropperPicture",
        webSite: process.env.VUE_ZHENGTAO_WEB,
        webNavbarList: [],
        drawer: false,
        info: {},
        saveTitle: "",
        keyword: "",
        showSearch: false, //控制搜索框的弹出
        showHead: false, //控制导航栏的弹出
        showUploadBlog: false, // 显示上传文章
        isCdTopVisible: false,
        isVisible: true, //控制web端导航的隐藏和显示
        isLogin: false,
        showLogin: false, //显示登录框
        userInfo: { // 用户信息
        },
        feedback: {}, //反馈提交
        blogLink: {}, //友链申请
        icon: false, //控制删除图标的显示
        labelWidth: "80px",
        commentList: [], //我的评论
        replyList: [], //我的回复
        praiseList: [], //我的点赞
        feedbackList: [], //我的反馈
        userBlogList: [], // 用户博客列表
        userQuestionList: [], // 用户问答列表
        creditsLogList:[],//记忆流水列表
        pointsLogList:[],//积分流水列表
        collectList: [], // 用户收藏列表
        openComment: "0", //是否开启评论
        defaultAvatar: process.env.defaultAvatar, // 默认头像
        drawerSize: "33%",
        userReceiveCommentCount: 0, // 用户收到的评论数
        userReceivePraiseCount: 0, // 用户收到的点赞数
        userReceiveSystemCount: 0, // 用户收到的系统通知数
        userReceiveWatchCount: 0, // 用户收到的关注数
        userReceiveMessageCount: 0, // 用户收到的消息数
        userReceiveCollectCount: 0, // 用户收到的收藏数
        isEdit: false, // 是否编辑博客
        formData: {}, // 表单数据
        questionFormData: {}, // 问答数据
        problemFormData: {}, // 面经数据
        showCreateBlog: false, // 是否显示用户创作按钮
        showCreateQuestion: false, // 是否显示创建问答按钮
        showChat: false, // 显示私信按钮
        browserFlag: 1, // 浏览器标志【默认Chrome】
        accountList: [], // 第三方綁定账号列表
        darkModel: 0, //暗黑模式 是否开启
        dialogHotSearchVisible: false,
        leaveTimeout: null, // 离开定时器
        withdrawRules: {
          account: [
            {required: true, message: '收款账号不能为空', trigger: 'blur'},
            {min: 0, max: 255, message: '长度在0到255个字符'},
          ],
          fileUid: [
            {required: true, message: '收款码不能为空', trigger: 'blur'},
          ],
          amount: [
            {required: true, message: '提现金额不能为空', trigger: 'blur'},
          ],
        },
        rules: {
          qqNumber: [
            {pattern:  /[1-9]([0-9]{5,11})/, message: '请输入正确的QQ号码'},
          ],
          email: [
            {pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请输入正确的邮箱'},
          ],
          nickName: [
            {min: 0, max: 20, message: '长度在0到20个字符'},
          ],
          occupation: [
            {min: 0, max: 10, message: '长度在0到10个字符'},
          ],
          summary: [
            {min: 0, max: 200, message: '长度在0到200个字符'},
          ],
        },
        linkRules: {
          title: [
            {required: true, message: '网站名称不能为空', trigger: 'blur'},
            {min: 1, max: 10, message: '长度在1到10个字符'},
          ],
          summary: [
            {required: true, message: '简介不能为空', trigger: 'blur'},
            {min: 1, max: 50, message: '长度在1到50个字符'},
          ],
          url: [
            {required: true, message: '网站地址不能为空', trigger: 'blur'},
            {pattern:  /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/, message: '请输入有效的URL'},
          ],
          email: [
            {pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请输入正确的邮箱'},
          ],
        },
        userInfoRules: {
          oldPwd: [
            {required: true, message: '旧密码不能为空', trigger: 'blur'},
            {min: 5, max: 20, message: '密码长度在5到20个字符'},
          ],
          newPwd: [
            {required: true, message: '新密码不能为空', trigger: 'blur'},
            {min: 5, max: 20, message: '密码长度在5到20个字符'},
          ],
          newPwd2: [
            {required: true, message: '新密码不能为空', trigger: 'blur'},
            {min: 5, max: 20, message: '密码长度在5到20个字符'},
          ]
        },
        personal: '',
        defaultAvatar: process.env.defaultAvatar, // 默认头像
        isWeiXinBrowser: isWeiXinBrowser,
        drawDialogVisible: false,
        lineLabelWidth: "80px", //一行的间隔数
        withdrawForm: {
          userName: "",
          account: ""
        },
        userAmount: 0, // 用户金额
      };
    },
    mounted() {
      let that = this;
      let offset = 300;
      let after = 0;
      window.addEventListener("scroll", function () {
        let scrollTop = document.documentElement.scrollTop; //当前的的位置
        let scrollHeight = document.documentElement.scrollHeight; //最高的位置
        if (scrollTop > offset) {
          that.isCdTopVisible = true;
        } else {
          that.isCdTopVisible = false;
        }
        if (scrollTop > after && scrollTop > 0) {
          that.isVisible = false;
        } else {
          if(scrollTop < 500) {
            that.isVisible = true;
          } else {
            that.isVisible = false;
          }
        }
        after = scrollTop;
      });

      // 屏幕自适应
      window.onresize = () => {
        return (() => {
          that.setSize()
        })()
      }
    },
    watch: {
      $route(to, from) {
        this.getCurrentPageTitle()
      },
      // 判断登录状态位是否改变（用于控制弹框）
      '$store.state.app.loginMessage': function (newFlag, oldFlag) {
          this.showLogin = true
      },
      // 判断登录状态位是否改变（用于控制弹框）
      '$store.state.app.createQuestionMessage': function (newFlag, oldFlag) {
        this.questionDialogFormVisible = true
      },
      // 判断 发表面经弹出框状态位是否改变(用于控制弹出框)
      '$store.state.app.createProblemMessage': function (newFlag, oldFlag) {
        this.dialogProblemFormVisible = true
      },
      'isLogin':{
        handler(val) {
          if (val) {
            //url中指定打开的界面
            if(this.$route.query.personal){
              this.personal = this.$route.query.personal
              switch(this.personal) {
                case "points": {
                    this.drawer = true;
                    this.activeName ="points"
                    this.getPointsList(true)
                } break;
                default: {
                  console.log(this.personal)
                }
              }
            }
          }
        }
      }
    },
    metaInfo() {
      return {
        title: this.info.title,
        link: [
          { rel: 'icon', href: this.info.logoPhoto }
        ],
        meta: [
          // {
          //   name: "keywords",
          //   content: this.info.keyword,
          // },
          // {
          //   name: "content",
          //   content: this.info.summary,
          // },
          // {
          //   name: "description",
          //   content: this.info.summary,
          // },
          // {
          //   property: "site_name",
          //   content: this.info.name,
          // },
        ],
      };
    },
    updated() {
      this.update()
    },
    created() {
      // 字典查询
      this.getDictList()
      this.getToken()
      this.getKeyword()
      this.getCurrentPageTitle()
      this.getWebConfigInfo()
      this.getWebNavbarList()
      this.setSize()
      this.setUserReceiveCommentCount()
      // 获取浏览器类型
      this.getBrowser()
      // 获取搜索模式
      this.getBlogSearchModel()

      // 获取专题是否显示
      let darkModel = getCookie("darkModel")
      if (darkModel && darkModel == "1") {
        this.darkModel = 1
        window.document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        this.darkModel = 0
        window.document.documentElement.setAttribute('data-theme', 'light')
      }
    },
    methods: {
      //拿到vuex中的写的方法
      ...mapMutations(['setUserInfo', 'setLoginState', 'setWebConfigData', 'setNoticeType', 'setCommentReportDict']),
      /*document.addEventListener('mouseup',(e)=>{
        var card =document.querySelector('.box-card') //选择返回的第一个出现的元素
        if(card){
          if(!card.contains(event.target)){ //判断某个元素不是目标元素的子元素 即目标元素以外的区域
            this.dialogHotSearchVisible=false
          }
        }
      }),*/
      // 申请提现
      withdrawAmount() {
        if (this.userAmount == 0) {
          this.$message.error("当前钱包金额为0，无法发起提现！")
          return
        }
        this.withdrawForm = this.getWithdrawFormObject()
        this.getRecentWithdrawRecord()
        this.drawDialogVisible = true
      },
      // 获取最近的一次提现记录
      getRecentWithdrawRecord() {
        console.log("获取用户最近抽奖记录")
        getRecentWithdraw().then(response => {
          console.log("获取用户最近抽奖记录", response)
          let data = response.data
          if (data) {
            this.withdrawForm.account = data.account
            this.withdrawForm.photoUrl = data.photoUrl
            this.withdrawForm.fileUid = data.fileUid
          }

        })
      },
      getWithdrawFormObject: function () {
        let withdrawForm = {
          account: "",
          fileUid: "",
          amount: this.userAmount / 100,
        };
        return withdrawForm;
      },
      // 提交提现申请
      submitWithdraw() {
        let params = {}
        params.amount = this.withdrawForm.amount * 100
        params.account = this.withdrawForm.account
        params.fileUid = this.withdrawForm.fileUid
        addWithdraw(params).then(resp => {
          if (resp.code == this.$ECode.SUCCESS) {
            this.$message.success("申请提现成功，请耐心等待管理员审核")
          } else {
            this.$message.error("提现失败")
          }
          this.drawDialogVisible = false
          this.getUserAmountMethod()
        })
      },
      getWithdrawFormObject: function () {
        let withdrawForm = {
          account: "",
          fileUid: "",
          amount: this.userAmount / 100,
        };
        return withdrawForm;
      },
      getUserAmountMethod() {
        getCurrentUserAmount().then(resp => {
          if (resp.code == this.$ECode.SUCCESS) {
            this.userAmount = resp.data
          }
        })
      },
      showHotSearch: function () {
        this.dialogHotSearchVisible = true;
      },
      chooseitem: function (data) {
        this.keyword = data
        this.search();
        this.onLeaveTd(false)
      },
      // 搜索
      search: function () {
        if (this.keyword == "" || this.keyword.trim() == "") {
          this.$notify.error({
            title: '错误',
            message: "关键字不能为空",
            type: 'success',
            offset: 100
          });
          return;
        }
        addHotSearch (this.keyword).then(result => {
          if (result.code == this.$ECode.SUCCESS) {
          }
        })
        if(this.$route.path=='/userCenter'){
          this.$router.push({
            path:this.$route.fullPath,
            query: {keyword: this.keyword, model: this.searchModel}
          })
        }else {
          this.$router.push({path: "/list", query: {keyword: this.keyword, model: this.searchModel}}).catch(err => {err});
        }
      },
      //获取对应markdown代码块标签
      update() {
        setTimeout(() => {
          document.querySelectorAll('pre').forEach(el => {
            if (el.classList.contains('code-copy-added')) {
              return
            }
            //   https://cn.vuejs.org/v2/api/index.html#Vue-extend
            /* 使用基础 Vue 构造器，创建一个“子类”。参数是一个包含组件选项的对象 */
            let ComponentClass = Vue.extend(CodeCopy)
            let instance = new ComponentClass()
            instance.code = el.innerText
            instance.parent = el
            /* 手动挂载 */
            instance.$mount()
            el.classList.add('code-copy-added')
            el.appendChild(instance.$el)
          })
        }, 100)
      },
      changeDarkModel(darkModel){
        if (darkModel == 1) {
          console.log("切换暗黑模式")
          window.document.documentElement.setAttribute('data-theme', 'dark')
        } else {
          console.log("切换亮白模式")
          window.document.documentElement.setAttribute('data-theme', 'light')
        }
        setCookie("darkModel", darkModel, 31)
        this.darkModel = darkModel
      },
      refreshWechatBind() {
        this.goBind('wechat')
      },
      goBind(source) {
        // 判断是否点击公众号登录
        if(source == "wechat") {
          this.wechatBindDialogVisible = true
          console.log("点击公众号登录")
          getBindKey().then(response => {
            console.log("获取绑定的key", response)
            if (response.code == this.$ECode.SUCCESS) {
              let bindInfo = response.data
              this.bindInfo = bindInfo
              let count = 0
              let interval = setInterval(() => {
                count++
                // 当检查15次未扫码的时候，将二维码失效，重试关闭接口请求
                if(count > 30) {
                  this.wechatLoginKey.bindKey = "验证码失效,请刷新"
                  clearInterval(interval)
                }
                let params = {}
                params.code = bindInfo.bindKey
                params.ticket = bindInfo.ticket
                loginCheck(params).then(response => {
                  if(response.code == this.$ECode.SUCCESS) {
                    // 判断url中是否含有token
                    let token = response.data
                    if (token != undefined) {
                      // 设置token七天过期
                      setCookie("token", token, 31)
                      location.replace(this.webSite);
                    }
                  }
                });
              }, 3000);
            }
          })
          return
        }
        // 判断是否绑定账号密码登录
        if(source == "password") {
          this.accountNumberBindDialogVisible = false
          getBindKey().then(response => {
            console.log("获取绑定的key", response)
            if (response.code == this.$ECode.SUCCESS) {
              let bindInfo = response.data
              this.bindInfo = bindInfo
              let count = 0
              let interval = setInterval(() => {
                count++
                // 当检查15次未扫码的时候，将二维码失效，重试关闭接口请求
                if(count > 30) {
                  this.wechatLoginKey.bindKey = "验证码失效,请刷新"
                  clearInterval(interval)
                }
                let params = {}
                params.code = bindInfo.bindKey
                params.ticket = bindInfo.ticket
                loginCheck(params).then(response => {
                  if(response.code == this.$ECode.SUCCESS) {
                    // 判断url中是否含有token
                    let token = response.data
                    if (token != undefined) {
                      // 设置token七天过期
                      setCookie("token", token, 31)
                      location.replace(this.webSite);
                    }
                  }
                });
              }, 3000);
            }
          })
          return
        }
        // 正常的绑定流程
        let params = new URLSearchParams();
        params.append("source", source);
        params.append("type", "bind");
        login(params).then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            window.location.href = response.data.url
          }
        });
      },
      setLoginTypeList: function() {
        // 获取登录方式列表
        let webConfigData = this.$store.state.app.webConfigData
        this.webConfig = webConfigData
        if(webConfigData.loginTypeList != undefined) {
          let loginTypeList = JSON.parse(webConfigData.loginTypeList)
          for(let a=0; a<loginTypeList.length; a++) {
            switch (loginTypeList[a]) {
              case "1": {
                this.loginType.password = false
              } break;
              case "2": {
                this.loginType.gitee = false
              } break;
              case "3": {
                this.loginType.github = false
              } break;
              case "4": {
                this.loginType.qq = false
              } break;
              case "5": {
                this.loginType.wechat = false
              } break;
              default: {
                console.log("登录方式设置有误！！")
              }
            }
          }
        }
      },
      clickWebNavbar: function (webNavbar) {
        if (this.info.title && webNavbar.name) {
          document.title = this.info.title + " | " + webNavbar.name
        }
      },
      getBlogSearchModel: function () {
        getSearchModel().then(response => {
          if(response.code == this.$ECode.SUCCESS) {
            this.searchModel = response.data
          }
        })
      },
      setSize() {
        // 屏幕大于950px的时候，显示侧边栏
        let clientWidth = document.body.clientWidth
        if(clientWidth > 1360) {
          this.drawerSize = "33%";
          this.showSearch = true
        }else if(clientWidth <= 1360 && clientWidth > 950) {
          this.drawerSize = "50%";
          this.showSearch = false
        } else if(clientWidth < 950 && clientWidth > 650) {
          this.drawerSize = "70%";
          this.showSearch = false
        } else {
          this.drawerSize = "95%";
          this.showSearch = false
        }
      },
      loadContent: function () {
        this.currentPage = this.currentPage + 1;
      },
      cancelCollect(bizUid, collectType) {
        let isLogin = this.$store.state.user.isLogin
        if(!isLogin) {
          this.$notify.error({
            title: '警告',
            message: '登录后才可以收藏哦~',
            offset: 100
          });
          // 未登录，自动弹出登录框
          this.setLoginMessage(Math.random())
          return;
        }
        let params = {}
        params.bizUid = bizUid
        params.collectType = collectType
        deleteCollect(params).then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            this.$message.success(response.message)
            this.getCollectList(true)
          } else {
            this.$message.error(response.message)
          }
        })
      },
      // 跳转到个人中心页
      getUserCenter: function (blog) {
        console.log("跳转到用户中心", blog)
        // 判断是后台添加，还是前台投稿
        if(blog.articleSource == 0) {
          let routeData = this.$router.resolve({
            path: "/userCenter",
            query: {adminUid: blog.adminUid}
          });
          window.open(routeData.href, '_blank');
        } else {
          let routeData = this.$router.resolve({
            path: "/userCenter",
            query: {userUid: blog.userUid}
          });
          window.open(routeData.href, '_blank');
        }
      },
      //跳转到文章详情
      goToInfo(blog) {
        console.log("跳转", blog)
        let routeData = this.$router.resolve({
          path: "/info/" + blog.oid
        });
        window.open(routeData.href, '_blank');
      },
      //跳转到问答详情
      goToQuestionInfo(question) {
        console.log("跳转", question)
        let routeData = this.$router.resolve({
          path: "/qInfo/" + question.oid
        });
        window.open(routeData.href, '_blank');
      },
      //跳转到问答详情
      goToUserMoment(userMoment) {
        console.log("跳转", userMoment)
        let routeData = this.$router.resolve({
          path: "/moment",
          query: {uid: userMoment.uid}
        });
        window.open(routeData.href, '_blank');
      },
      //跳转到问答详情
      goToProblem(problem) {
        console.log("跳转", problem)
        let routeData = this.$router.resolve({
          path: "/cInfo/" + problem.uid
        });
        window.open(routeData.href, '_blank');
      },
      // 获取导航栏列表
      getWebNavbarList() {
        let params = {};
        getWebNavbar(params).then(response => {
          if(response.code == this.$ECode.SUCCESS) {
            this.webNavbarList = response.data
            // setCookie("webNavbarList", JSON.stringify(webNavbarList), 1)
          }
        })
      },
      // 跳转到资源详情
      goSource: function(comment) {
        let source = comment.source
        switch(source) {
          case "MESSAGE_BOARD": {
            let routeData = this.$router.resolve({
              path: "/messageBoard"
            });
            window.open(routeData.href, '_blank');
          };break;
          case "BLOG_INFO": {
            let routeData = this.$router.resolve({
              path: "/info",
              query: {blogUid: comment.blogUid}
            });
            window.open(routeData.href, '_blank');
          };break;
          case "ABOUT": {
            let routeData = this.$router.resolve({
              path: "/about"
            });
            window.open(routeData.href, '_blank');
          };break;
        }
      },

      // 获取评论列表
      getCommentList: function(isClean) {
        if (isClean){
          this.commentList=[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        getCommentListByUser(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let commentList = response.data.records
            this.commentList = this.commentList.concat(commentList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (commentList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },

      // 获取评论列表
      getCollectList: function(isClean) {
        if (isClean){
          this.collectList=[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        getUserCollectList(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let collectList = response.data.records
            this.collectList = this.collectList.concat(collectList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (collectList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },

      // 获取记忆列表
      getCreditsList: function(isClean) {
        if (isClean){
          this.creditsLogList =[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        this.loading = true
        getCreditsListByUser(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let creditsLogList = response.data.records
            console.log(creditsLogList);
            this.creditsLogList = this.creditsLogList.concat(creditsLogList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (creditsLogList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },
      // 获取积分列表
      getPointsList: function(isClean) {
        if (isClean){
          this.pointsLogList =[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        this.loading = true
        getPointsListByUser(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let pointsLogList = response.data.records
            console.log(pointsLogList);
            this.pointsLogList = this.pointsLogList.concat(pointsLogList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (pointsLogList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },
      // 获取回复列表
      getReplyList: function(isClean) {
        if (isClean){
          this.replyList=[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        this.loading = true
        getReplyListByUser(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let replyList = response.data.records
            this.replyList = this.replyList.concat(replyList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (replyList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },

      // 获取反馈列表
      getFeedback: function(isClean) {
        let params = {}
        getFeedbackList(params).then(response => {
          if(response.code == this.$ECode.SUCCESS) {
            this.feedbackList = response.data.records;
          }
        })
      },

      // 获取点赞列表
      getPraiseList: function(isClean) {
        if (isClean){
          this.praiseList=[];
        }
        let params = {}
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        getPraiseListByUser(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let praiseList = response.data.records
            this.praiseList = this.praiseList.concat(praiseList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (praiseList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },

      // 获取用户博客列表
      getBlogList: function(isClean) {
        if (isClean){
          this.userBlogList= [];
        }
        let params = {}
        params.auditStatus = this.queryParams.auditStatusKeyword
        params.isPublish = this.queryParams.publishKeyword
        params.isOriginal = this.queryParams.originalKeyword
        params.keyword = this.queryParams.keyword
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        getMeBlogList(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let userBlogList = response.data.records
            this.userBlogList = this.userBlogList.concat(userBlogList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (userBlogList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false
        })
      },
      changeEnablePoints(val){
        let that = this
        updateEnablePoints({'enablePoints': val}).then(response =>{
          that.$commonUtil.message.success(response.message)
        })
      },

      // 获取用户问题列表
      getUserQuestionList: function(isClean) {
        if (isClean){
          this.userQuestionList= [];
        }
        let params = {}
        params.isPublish = this.queryParams.publishKeyword
        params.keyword = this.queryParams.keyword
        params.pageSize = this.pageSize;
        params.currentPage = this.currentPage;
        getMeQuestionList(params).then(response => {
          if(response.code == this.$ECode.SUCCESS  && response.data.records.length > 0) {
            let userQuestionList = response.data.records
            this.userQuestionList = this.userQuestionList.concat(userQuestionList);
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
            //全部加载完毕
            if (userQuestionList.length < this.pageSize) {
              this.isEnd = true;
            }
          } else {
            this.isEnd = true
          }
          this.loading = false

        })
      },

      // 删除博客
      handleDeleteBlog: function(row) {
        let that = this;
        this.$confirm("此操作将把博客删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = {};
            params.uid = row.uid;
            deleteBlog(params).then(response => {
              that.$commonUtil.message.success(response.message)
              that.getBlogList(true);
            });
          }).catch(() => {
            that.$commonUtil.message.info("已取消删除")
          });
      },
      handleDownload: function (object, type) {
        if(type == "blog") {
          // 下载博客
          let params = new URLSearchParams()
          params.append("blogUid", object.uid)
          downloadBlog(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$commonUtil.htmlToMarkdownFile(object.title, object.content)
            }
          })

        } else {
          this.$commonUtil.htmlToMarkdownFile(object.title, object.content)
        }
      },
      // 删除问答
      handleDeleteQuestion: function(row) {
        let that = this;
        this.$confirm("此操作将把问答删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = {};
            params.uid = row.uid;
            deleteQuestion(params).then(response => {
              that.$commonUtil.message.success(response.message)
              that.getUserQuestionList(true);
            });
          })
          .catch(() => {
            that.$commonUtil.message.info("已取消删除")
          });
      },
      userBindAccountList() {
        getAccountBindList().then(response=> {
          if (response.code == this.$ECode.SUCCESS) {
            this.accountList = response.data
          }
        })
      },

      // 标签选择
      handleClick(tab, event) {
        this.currentPage = 1
        this.queryParams = {
            keyword: "",
            tagKeyword: "", //标签搜索
            sortKeyword: "", //分类搜索
            publishKeyword: "", // 发布 搜索
            originalKeyword: "", // 原创 搜索
            openCommentKeyword: "", // 开启评论
            auditStatusKeyword: "", // 审核状态
        } // 搜索条件
        this.query
        this.isLoading = false
        this.isEnd = false
        this.userQuestionList = []
        this.userBlogList = []
        this.praiseList = []
        this.commentList = []
        this.replyList = []
        switch(tab.label) {
          case "个人中心": {
            console.log("点击个人中心")

          } break;
          case "账号绑定": {
            console.log("账号绑定")
            this.setLoginTypeList()
            this.userBindAccountList()
          } break;
          case "我的文章": {
            this.getBlogList(true)
          } break;
          case "我的问答": {
            this.getUserQuestionList(true)
          } break;
          case "我的收藏": {
            this.getCollectList(true)
          } break;
          case "我的评论": {
            this.getCommentList(true);
          } break;
          case "我的回复": {
            this.getReplyList(true);
          } break;
          case "我的记忆": {
            this.getCreditsList(true);
          } break;
          case "我的积分": {
            this.getPointsList(true);
          } break;
          case "我的点赞": {
            this.getPraiseList(true)
          } break;
          case "我的反馈": {
            this.getFeedback(true)
          } break;
          case "申请友链": {
            console.log("点击申请友链")
          } break;
          case "修改密码": {
            console.log("点击修改密码")
          } break;
        }
      },

      // 跳转到资源详情
      loadMore: function(type) {
        this.currentPage = this.currentPage + 1;
        switch(type) {
          case "comment": {
            this.getCommentList(false)
          } break;
          case "praise": {
            this.getPraiseList(false)
          } break;
          case "reply": {
            this.getReplyList(false)
          } break;
          case "credits": {
            this.getCreditsList(false)
          } break;
          case "feedback": {
            // this.getFeedback()
          } break;
          case "blog": {
            this.getBlogList(false)
          } break;
          case "question": {
            this.getUserQuestionList(false)
          } break;
          case "collect": {
            this.getCollectList(false)
          } break;
          case "points": {
            this.getPointsList(false)
          } break;
        }
      },

      //弹出选择图片框
      checkPhoto() {
        this.imagecropperShow = true
      },
      /**
       * dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
       * @param dateTimeStamp
       * @returns {string}
       */
      timeAgo(dateTimeStamp) {
        return timeAgo(dateTimeStamp)
      },

      cropSuccess(resData) {
        console.log("裁剪成功", resData)
        this.imagecropperShow = false
        this.imagecropperKey = this.imagecropperKey + 1
        if (this.drawDialogVisible) {
          // 判断是提现页面
          this.withdrawForm.photoUrl = resData.url
          this.withdrawForm.fileUid = resData.uid
          console.log("操作的提现页面", this.withdrawForm)
        }else if(this.activeName == "0") {
          // 激活个人中心页面
          this.userInfo.photoUrl = resData.url
          this.userInfo.avatar = resData.uid
        } else if(this.activeName == "5") {
          let photoList = []
          photoList.push(resData.url);
          this.blogLink.photoList = photoList
          this.blogLink.fileUid = resData.uid
        }
      },

      deletePhoto: function(type) {
        switch (type) {
          case "user": {
            this.userInfo.photoUrl = null;
            this.userInfo.avatar = "";
            this.icon = false;
          } break;

          case "link": {
            this.blogLink.photoList = null;
            this.icon = false;
          } break;
        }
      },

      onCardEnterTd: function () {
        clearTimeout(this.leaveTimeout)
      },
      //鼠标离开的事件。
      onLeaveTd (nowClean) {
        console.log("触发离开配置")
        let that = this
        if (nowClean) {
          that.dialogHotSearchVisible = false;
        } else {
          this.leaveTimeout = setTimeout(() => {
            that.dialogHotSearchVisible = false;
          }, 500)
        }
      },


      close() {
        this.imagecropperShow = false
      },
      submitForm: function(type) {
        switch (type) {
          case "editUser": {
            this.$refs.userInfo.validate((valid) => {
              if(!valid) {
                console.log("校验失败")
              } else {
                editUser(this.userInfo).then(response => {
                  if(response.code == this.$ECode.SUCCESS) {
                    this.$message({
                      type: "success",
                      message: response.data
                    })
                  } else {
                    this.$message({
                      type: "error",
                      message: response.message
                    })
                  }
                });
              }
            })
          }; break;

          case "replyBlogLink": {
            this.$refs.blogLink.validate((valid) => {
              if(!valid) {
                console.log("校验失败")
              } else {
                replyBlogLink(this.blogLink).then(response => {
                  if(response.code == this.$ECode.SUCCESS) {
                    this.$message({
                      type: "success",
                      message: response.data
                    })
                  } else {
                    this.$message({
                      type: "error",
                      message: response.message
                    })
                  }
                });
              }
            })
          } break;

          case "feedback": {
            let feedback = this.feedback
            if(feedback.title == undefined || feedback.title == "" || feedback.content == undefined || feedback.content == "") {
              this.$message({
                type: "error",
                message: "必填项不能为空"
              })
              return;
            }
            addFeedback(this.feedback).then(response => {
              if(response.code == this.$ECode.SUCCESS) {
                this.$message({
                  type: "success",
                  message: response.data
                })
                this.feedback = {}
                this.getFeedback()
              } else {
                this.$message({
                  type: "error",
                  message: response.message
                })
              }
            });
          }; break;

          case "changePwd": {
            let newPwd = this.userInfo.newPwd
            let newPwd2 = this.userInfo.newPwd2
            let oldPwd = this.userInfo.oldPwd
            if(newPwd != newPwd2) {
              this.$message({
                type: "error",
                message: "两次密码不一致"
              })
              return
            }
            if(newPwd == oldPwd) {
              this.$message({
                type: "error",
                message: "新旧密码相同"
              })
              return
            }
            let params = new URLSearchParams()
            params.append("oldPwd", oldPwd)
            params.append("newPwd", newPwd)
            updateUserPwd(params).then(response => {
              if(response.code == this.$ECode.SUCCESS) {
                this.$message({
                  type: "success",
                  message: response.data
                })
              } else {
                this.$message({
                  type: "error",
                  message: response.message
                })
              }
              // 重置表单
              this.$refs.userInfoForm.resetFields()
            })
          };break;
        }
      },

      /**
       * 字典查询
       */
      getDictList: function () {
        let dictTypeList =  ['sys_yes_no', 'sys_user_sex', 'sys_feedback_status', 'sys_editor_modal', 'sys_content_report_type', 'sys_original_status', 'sys_publish_status', 'sys_audit_status', 'sys_normal_disable', 'sys_publish_status']
        getListByDictTypeList(dictTypeList).then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            let dictMap = response.data;
            this.genderDictList = dictMap.sys_user_sex.list
            this.yesNoDictList = dictMap.sys_yes_no.list
            this.feedbackDictList = dictMap.sys_feedback_status.list
            this.editorModalDictList = dictMap.sys_editor_modal.list
            this.commentReportDictList = dictMap.sys_content_report_type.list
            this.blogOriginalDictList = dictMap.sys_original_status.list
            this.blogPublishDictList = dictMap.sys_publish_status.list
            this.auditStatusDictList = dictMap.sys_audit_status.list
            this.openDictList = dictMap.sys_normal_disable.list
            if(dictMap.sys_content_report_type.defaultValue) {
              this.commentReportDictDefault = dictMap.sys_content_report_type.defaultValue;
            }
            let commentReportDict = {}
            commentReportDict.list = this.commentReportDictList
            commentReportDict.default = this.commentReportDictDefault
            this.setCommentReportDict(commentReportDict)
          }
        });
      },

      getToken: function() {
        let token = this.getUrllets()["token"];
        // 判断url中是否含有token
        if (token) {
          // 设置token 31天过期
          setCookie("token", token, 31)
        } else {
          // 从cookie中获取token
          token = getCookie("token")
        }
        // 从url和cookie中获取token，在去校验
        if (token) {
          authVerify(token).then(response => {
            if (response && response.code == this.$ECode.SUCCESS) {
              console.log("校验token成功", response)
              this.isLogin = true;
              this.userInfo = response.data;
              // 获取用户标识
              let userTag = this.userInfo.userTag
              if(userTag > 0) {
                this.showUploadBlog = true
              }
              this.setUserInfo(this.userInfo)
            } else {
              console.log("校验token失败")
              this.isLogin = false;
              delCookie("token");
              if (/(micromessenger)/i.test(navigator.userAgent)) {
                //可能存在token，但校验后发现已过期，微信环境下刷新一下触发路由中的自动登录了
                location.reload();
              }
            }
            this.setLoginState(this.isLogin);
            // 获取原页面地址，登录后进行跳转到原页面，如果为空或者就是在首页登录，不进行跳转
            const redirectUrl = getCookie("redirectUrl");
            if (redirectUrl != undefined && redirectUrl != "" && redirectUrl != "/") {
              window.location.href = redirectUrl;
              // 清除缓存的原页面地址
              delCookie("redirectUrl");
              return;
            }
          });
        } else {
          this.isLogin = false;
          this.setLoginState(this.isLogin);
        }
      },
      /**********文章 发布与下架  *************/
      handlePublish: function(row) {
        let that = this;
        if (row.isPublish == 1){
          this.$confirm("此操作将下架博客, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let params = {};
            params.uid = row.uid;
            params.isPublish = 0;
            publishBlog(params).then(response => {
              that.$commonUtil.message.success(response.message)
              that.getBlogList(true)
            });
          }).catch(() => {
              that.$commonUtil.message.info("已取消下架")
            });
        }
        if (row.isPublish == 0) {
          this.$confirm("此操作将发布博客, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let params = {};
            params.uid = row.uid;
            params.isPublish = 1;
            publishBlog(params).then(response => {
              that.$commonUtil.message.success(response.message)
              that.getBlogList(true)
            });
          }).catch(() => {
            that.$commonUtil.message.info("已取消发布")
          });
        }
      },
      handleAudit: function(row) {
        let params = row;
        params.isPublish = 1;
        editBlog(params).then(response => {
          this.$commonUtil.message.success(response.message)
          this.getBlogList(true)
        });
      },
      /********************** 创作相关 ********************/
      createBlog: function (isEdit, formData) {

        this.isEdit = isEdit
        if(isEdit ) {
          this.formData = formData
        }
        if(!this.isLogin) {
          this.showLogin = true;
          return
        }
        /**
         * 修改 已审核过的文章  提示 将会使文章审核状态变更为未审核 进入重新审核流程
         */
        if (isEdit && formData.auditStatus == 2) {
          this.$confirm("修改已审核通过的文章,博客将会被重新审核, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.dialogFormVisible = true
          }).catch(() => {
            this.$commonUtil.message.info("已取消修改")
          });
        } else if (isEdit && formData.auditStatus == 1){
          this.$confirm("请按照审核提示修改文章！重新提交博客后，将会被重新审核，是否继续? ", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.dialogFormVisible = true
          }).catch(() => {
            this.$commonUtil.message.info("已取消修改")
          });
        }else {
          this.dialogFormVisible = true
        }
      },
      // 关闭模态框回调函数
      beforeClose: function () {
        this.dialogFormVisible = false
        this.dialogUploadBlogVisible = false
      },
      /********************** 创作相关结束 ********************/

      /********************** 创作相关 ********************/
      uploadBlog: function () {
        this.dialogUploadBlogVisible = true
      },
      /********************** 创作相关结束 ********************/

      /********************** 创作相关 ********************/
      createQuestion: function (isEdit, formData) {
        this.isEdit = isEdit
        if(isEdit) {
          this.questionFormData = formData
        }
        if(!this.isLogin) {
          this.showLogin = true;
          return
        }
        this.questionDialogFormVisible = true
      },
      // 关闭模态框回调函数
      questionBeforeClose: function () {
        this.questionDialogFormVisible = false
      },
      createProblem: function (isEdit, formData) {
        this.isEdit = isEdit
        if(isEdit) {
          this.problemFormData = formData
        }
        if(!this.isLogin) {
          this.showLogin = true;
          return
        }
        this.dialogProblemFormVisible = true
      },
      // 关闭面经模态框回调函数
      problemBeforeClose: function () {
        console.log("关闭模态框")
        this.dialogProblemFormVisible = false
      },
      /********************** 创作相关结束 ********************/

      setUserReceiveCommentCount: function () {
        getUserReceiveNoticeCount().then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            this.userReceiveCommentCount = response.data.userReceiveCommentCount
            this.userReceivePraiseCount = response.data.userReceivePraiseCount
            this.userReceiveSystemCount = response.data.userReceiveSystemCount
            this.userReceiveWatchCount = response.data.userReceiveWatchCount
            this.userReceiveMessageCount = response.data.userReceiveMessageCount
            this.userReceiveCollectCount = response.data.userReceiveCollectCount
          }
        });
      },
      getKeyword: function() {
        let tempValue = decodeURI(this.getUrllets()["keyword"]);
        if (
          tempValue == null ||
          tempValue == undefined ||
          tempValue == "undefined"
        ) {
        } else {
          this.keyword = tempValue;
        }
      },
      /**
       * 获取当前所在页面的标题
       * @returns {{}}
       */
      getCurrentPageTitle: function() {
        // 判断是否是通过参数传递的title
        let title = this.getUrllets()["title"];
        console.log("获取url", title)
        if(title) {
          // 如果是通过参数传递，那么直接显示
          this.saveTitle = title;
        } else {
          // 从url中获取title
          let test = window.location.href;
          let start = 0;
          let end = test.length;
          for (let i = 0; i < test.length; i++) {
            if (test[i] == "/") {
              start = i;
            }
            if (test[i] == "?" && i > start) {
              end = i;
            }
          }
          let result = test.substring(start, end);
          this.saveTitle = result;
        }
      },
      /**
       * 获取网站配置
        */
      getWebConfigInfo: function() {
        let webConfigData = this.$store.state.app.webConfigData
        if(webConfigData.createTime) {
          this.contact = webConfigData;
          this.mailto = "mailto:" + this.contact.email;
          this.openComment = webConfigData.openComment
          document.title = this.info.title
          this.showCreateBlog = webConfigData.openCreateBlog == "1" ? true:false
          this.showCreateQuestion = webConfigData.openCreateQuestion == "1" ? true:false
          this.showChat = webConfigData.openChat == "1" ? true:false
        } else {
          getWebConfig().then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.info = response.data;
              // 存储在Vuex中
              this.setWebConfigData(response.data)
              this.openComment = this.info.openComment
              document.title = this.info.title
              this.showCreateBlog = this.info.openCreateBlog == "1" ? true:false
              this.showCreateQuestion = this.info.openCreateQuestion == "1" ? true:false
              this.showChat = this.info.openChat == "1" ? true:false
            }
          });
        }
      },
      /**
       * 截取URL中的参数
       * @returns {{}}
       */
      getUrllets: function () {
        let lets = {};
        let url = window.location.href;
        url = decodeURI(url)
        let parts = url.replace(
          /[?&]+([^=&]+)=([^&#]*)/gi,
          function (m, key, value) {
            lets[key] = value;
          }
        );
        return lets;
      },
      clickSearchIco: function () {
        if(this.keyword != "") {
          this.search();
        }
        this.showSearch = !this.showSearch;
        //获取焦点
        this.$refs.searchInput.focus();
      },
      openHead: function () {
        this.showHead = !this.showHead;
      },
      returnTop: function () {
        window.scrollTo(0, 0);
      },
      userLogin: function () {
        this.showLogin = true;
      },
      userLogout: function () {
        deleteUserAccessToken(getCookie("token"));
        delCookie("token");
        let url = window.parent.location.href;
        let haveToken = url.indexOf("?token")
        if (haveToken != -1) {
          let list = url.split("?token");
          this.isLogin = false;
          window.location.href = list[0]
          let userInfo = {};
          this.setUserInfo(userInfo)
        } else {
          window.location.reload()
        }
      },

      // 点击头像触发的动作
      handleCommand(command) {
        switch (command) {
          case "logout" : {
            this.userLogout();
          };break;
          case "login" : {
            this.userLogin();
          };break;
          case "goUserCenter" : {
            this.$router.push({ path: "/userCenter", query: { userUid: this.userInfo.uid } });
          } break;
          case "goUserInfo" : {
            // 打开抽屉
            this.drawer = true;
            this.getUserAmountMethod()
          } break;
          case "createBlog" : {
            // 创作博客
            this.createBlog(false, null)
          } break;
          case "createProblem" : {
            // 发布面经
            this.createProblem(false, null)
          } break;
          case "createQuestion" : {
            this.createQuestion(false, null)
          } break;
          case "uploadBlog" : {
            this.uploadBlog()
          } break;
          case "userMoment": {
           this.$router.push({path: "/moment"});
          } break;
          case "comment" : {
            if(!this.isLogin) {
              this.showLogin = true;
              return
            }
            // 判断用户是否未读的回复
            if(this.userReceiveCommentCount > 0) {
              // 设置已阅读
              let params = {}
              params.noticeType = "1"
              this.readNotice()
              this.userReceiveCommentCount = 0
            }
            this.setNoticeType("1")
            this.$router.push({ path: "/notice", query: { noticeType: "1" } });
          } break;
          case "watch" : {
            if(!this.isLogin) {
              this.showLogin = true;
              return
            }
            // 设置已阅读
            let params = {}
            params.noticeType = "2"
            if(this.userReceiveWatchCount > 0) {
              this.readNotice()
              this.userReceiveWatchCount = 0
            }
            this.setNoticeType("2")
            this.$router.push({ path: "/notice", query: { noticeType: "2" } });
          } break;
          case "praise" : {
            if(!this.isLogin) {
              this.showLogin = true;
              return
            }
            // 设置已阅读
            let params = {}
            params.noticeType = "3"
            if(this.userReceivePraiseCount > 0) {
              this.readNotice()
              this.userReceivePraiseCount = 0
            }
            this.setNoticeType("3")
            this.$router.push({ path: "/notice", query: { noticeType: "3" } });
          } break;
          case "system" : {
            if(!this.isLogin) {
              this.showLogin = true;
              return
            }
            // 设置已阅读
            let params = {}
            params.noticeType = "4"
            if(this.userReceiveSystemCount > 0) {
              this.readNotice()
              this.userReceiveSystemCount = 0
            }
            this.setNoticeType("4")
            this.$router.push({ path: "/notice", query: { noticeType: "4" } });
          } break;
          case "collect" : {
            if(!this.isLogin) {
              this.showLogin = true;
              return
            }
            // 设置已阅读
            let params = {}
            params.noticeType = "6"
            if(this.userReceiveCollectCount > 0) {
              this.readNotice()
              this.userReceiveCollectCount = 0
            }
            this.setNoticeType("6")
            this.$router.push({ path: "/notice", query: { noticeType: "6" } });
          } break;
          case "message" : {
           this.goChat()
          } break;
        }
      },
      goChat() {
        if(!this.isLogin) {
          this.showLogin = true;
          return
        }
        // 设置已阅读
        let params = {}
        params.noticeType = "5"
        if(this.userReceiveMessageCount > 0) {
          this.readNotice()
          this.userReceiveMessageCount = 0
        }
        this.$router.push({ path: "/chat"});
      },
      readNotice() {
        readUserReceiveNoticeCount().then(response => {
          if(response.code == this.$ECode.SUCCESS) {
            // 阅读成功
            this.userReceiveSystemCount = 0
          }
        })
      },
      closeLoginBox: function () {
        this.showLogin = false;
      },
      // 获取浏览器类型, 用于兼容处理
      getBrowser() {
        let sBrowser, sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Firefox") > -1) {
          sBrowser = "Mozilla Firefox";
          this.browserFlag = 2;
          // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf("Chrome") > -1) {
          sBrowser = "Google Chrome or Chromium";
          this.browserFlag = 1;
          // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        }
      },
    }
  };
</script>

<style>
  @import "../assets/css/emoji.css";
  .emoji-panel-btn:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  .emoji-item-common {
    background: url("../assets/img/emoji_sprite.png");
    display: inline-block;
    zoom: 0.3;
  }
  .emoji-item-common:hover {
    cursor: pointer;
  }
  .emoji-size-small {
    zoom: 0.3;
  }

</style>

<style scoped lang="scss">

  .isEnd {
    float: left;
    width: 100%;
    height: 80px;
    text-align: center;
  }
  .loadContent {
    border-radius: 25px;
    width: 120px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    margin: 0 auto;
    color: aliceblue;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.8);
  }

  .createBlog {
    position: absolute;
    top: 16px;
    right: -20px;
  }

  .el-tag {
    height: 25px;
    line-height: 25px;
    margin-left: 6px;
  }
  #starlist li .title {
    color: #007fff;
  }

  .searchbox {
    position: absolute;
    right: 300px;
    top: 0;
    display: flex;
    flex-direction: column;
  }

  .searchboxDefault {
    position: absolute;
    right: 190px;
    top: 0
  }

  .create {
    width: 35px;
    height: 40px;
    position: absolute;
    right: 200px;
  }

  .notice {
    width: 35px;
    height: 35px;
    position: absolute;
    font-size: 24px;
    margin-top: 2px;
    right: 125px;
    cursor: pointer;
  }

  .userInfoAvatar {
    width: 35px;
    height: 35px;
    position: absolute;
    right: 70px;
    top: 12px;
  }


  .userInfoAvatar img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }


  .el-icon-bell:hover {
    color: #00ccff;
  }


  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin: 0, 0, 0, 10px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .imgBody {
    width: 100px;
    height: 100px;
    border: solid 2px #ffffff;
    float: left;
    position: relative;
  }
  .imgBody img {
    width: 100px;
    height: 100px;
  }
  .uploadImgBody {
    margin-left: 5px;
    width: 100px;
    height: 100px;
    border: dashed 1px #c0c0c0;
    float: left;
    position: relative;
  }
  .uploadImgBody :hover {
    border: dashed 1px #00ccff;
  }
  .inputClass {
    position: absolute;
  }

  .commentList {
    width: 100%;
    margin: 0 auto;
  }
  .commentList .p1 {
    float: left;
  }
  .commentList .left {
    display: inline-block;
    width: 10%;
    height: 100%;
  }
  .commentList .left img {
    margin: 0 auto;
    width: 100%;
    border-radius: 50%;
  }
  .commentList .right {
    display: inline-block;
    width: 85%;
    margin-left: 5px;
  }
  .commentList .rightTop {
    height: 30px;
  }
  .commentList .rightTop .userName {
    color: #303133;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .commentList .rightTop .timeAgo {
    color: #909399;
    margin-left: 10px;
    font-size: 15px;
  }
  .commentList .rightCenter {
    margin-left: 20px;
    line-height: 30px;
    min-height: 60px;
  }


  .feedbackCard .item .title {
    display: inline-block;
    width: 70px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
  }
  .feedbackCard .item .content {
    // display: inline-block;
    // width: 240px;
    // margin-bottom: 5px;
  }

  .myArticle .blogpic{
    float: left;
    max-height: 170px;
    margin-right: 20px;
    display: block;
    overflow: hidden;
  }
  .myArticle .blogpic img{
    width: 100%;
    max-height: 70px;
    -webkit-transition: all 0.6s ease;
    transition: all 0.6s ease;
    margin-bottom: 10px;
  }
  .myArticle .bloginfo {
    margin-top: 5px;
  }
  .myArticle .operation {
    float: right;
    margin-top: 3px;
    margin-bottom: 3px;
    // height: 40px;
  }
  .search_ico2 { width: 60px; height: 60px; display: block; position: absolute; right: 0; top: 15px; padding: 0; margin: 0; line-height: 60px; cursor: pointer; }

  @media only screen and (min-width: 1346px) and (max-width: 1432px) {
    .searchbox {
      position: absolute;
      right: 360px;
      top: 0
    }
    .searchboxDefault {
      position: absolute;
      right: 250px;
      top: 0
    }
    .create {
      right: 280px;
    }
    .notice {
      right: 200px;
    }
    .userInfoAvatar {
      right: 150px;
    }
  }

  @media only screen and (min-width: 1135px) and (max-width: 1345px) {
    .searchbox {
      position: absolute;
      right: 550px;
      top: 0
    }
    .searchboxDefault {
      position: absolute;
      right: 500px;
      top: 0
    }
    .create {
      right: 470px;
    }
    .notice {
      right: 400px;
    }
    .userInfoAvatar {
      right: 350px;
    }
  }

  @media only screen and (min-width: 649px) and (max-width: 1134px) {
    ::v-deep .el-dialog {
      width: 50% !important;
    }
    .searchbox {
      position: absolute;
      right: 150px;
      top: -2px;
    }
    .create {
      right: 50px;
      display: none;
    }
    .notice {
      right: 100px;
      top: -2px;
    }
    .userInfoAvatar {
      width: 35px;
      height: 35px;
      position: absolute;
      right: 45px;
      top: 10px;
    }
  }

  @media only screen and (max-width: 649px) {
    .searchbox {
      position: absolute;
      right: 75px;
      top: -3px;
    }
    .create {
      right: 50px;
      display: none;
    }
    .notice {
      right: 45px;
      top: -4px;
    }
    .userInfoAvatar {
      width: 35px;
      height: 35px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
    ::v-deep .el-dialog {
      width: 100% !important;
    }
  }
  .personalCenter ::v-deep .el-tabs__content{
    padding: 15px 5px;
    height: 100%;
    .el-tab-pane{
      height: 95%;
    }
    .el-card__body {
      padding: 5px;
    }
  }

.codeContent {
  max-width: 400px;
  margin: 0 auto;
  padding-top: 25vh;
}
.code-copy-added {
  background-color: #282c34;
  color: white;
  padding: 2px 2px;
  margin: 10px 0;
  text-align: left;
  border-radius: 3px;
  position: relative;
}
.code-copy-added:hover .copy-btn {
  opacity: 1;
}
.my-label {
    background: #E1F3D8;
  }

.my-content {
  background: #2dc9f073;
}
</style>
